<template>
  <div class="section-content">
    <div class="primary-section-content">
      <div class="header-class pt-3">
        <hb-header
          :divider="false"
          full
        >
          <hb-page-header
            title="End of Month"
            description="Set up reports and accounting exports to be delivered at the end of each month."
          >
          </hb-page-header>
        </hb-header>
        <hb-btn
          icon
          tooltip="Sidebar"
          class="pt-4"
          @click="showAside = !showAside"
          :active-by-default="true"
          :active-state-off="!showAside"
          >mdi-table-actions-custom-1</hb-btn
        >
      </div>
      <v-divider></v-divider>
      <div class="main-wraper-container">
        <!-- Main Content -->
        <div
          class="section-content pa-0 pt-4"
          :class="{
            'mt-10': $vuetify.breakpoint.xs,
            'mt-n3': $vuetify.breakpoint.sm,
          }"
        >
          <div class="pr-3">
            <report-configuration
              v-if="selectedMenu === 'Report Configuration'"
            />
            <company-history-table v-if="selectedMenu === 'Company History'" />
            <property-history-table
              v-if="selectedMenu === 'Property History'"
            />
          </div>
        </div>

        <sidebar-menu
          :activeIndex="selectedIndex"
          :menuItems="menuTypes"
          v-model="showAside"
          @openView="openTheView"
        ></sidebar-menu>
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
import ReportConfiguration from "./ReportConfiguration.vue";
import CompanyHistoryTable from "./CompanyHistoryTable.vue";
import PropertyHistoryTable from "./PropertyHistoryTable.vue";
import { EventBus } from "../../EventBus.js";
import SidebarMenu from "../../components/settings/Common/SidebarMenu.vue";

export default {
  name: "EndOfMonth",
  data() {
    return {
      showAside: true,
      showDrawer: false,
      showSidebar: true,
      selectedIndex: 0,
      menuTypes: [
        { name: "Report Configuration" },
        { name: "Company History" },
        { name: "Property History" },
      ],
      selectedMenu: "Report Configuration",
    };
  },
  props: {
    activeTab: {
      type: Object,
    },
    property_id: {
      type: String,
    },
  },
  components: {
    ReportConfiguration,
    CompanyHistoryTable,
    PropertyHistoryTable,
    SidebarMenu,
  },
  created() {
    EventBus.$on("showHideSidebar", this.showHideSidebar);
    EventBus.$on("openStageDrawer", this.handleOpenStageDrawer);
  },
  methods: {
    async showHideSidebar(val) {
      this.showAside = val === true ? true : false;
    },
    async openTheView(page) {
      this.selectedMenu = page.name;
    },
  },
  destroyed() {
    EventBus.$off("showHideSidebar", this.showHideSidebar);
    EventBus.$off("openStageDrawer");
  },
};
</script>
<style lang="scss" scoped>
.section-content {
  .header-class {
    display: flex;
    justify-content: space-between;
  }

  .main-wraper-container {
    display: flex;
    justify-content: space-between;
    height: calc(100vh - 73px);
  }

  .v-navigation-drawer__content a.v-list-item:not(.v-list-item--active) {
    background-color: #f9fafb !important;
    border-left: 4px solid #f9fafb;
  }

  .v-navigation-drawer__content a.v-list-item--active {
    background-color: #e2f2f3 !important;
    border-left: 4px solid #00848e;
  }
}
</style>
